import { ApiError } from "./client";
import { getStoredAttribution } from "../lib/attribution";

const BASE = process.env.REACT_APP_API_URL ?? "";

/**
 * POST /waitlist — deliberately unauthenticated: this is offered to visitors specifically
 * because they're blocked from creating an account, so there is no Firebase user to attach
 * a token to. Not routed through apiFetch, which requires one.
 */
export async function joinWaitlist(email: string, source: string): Promise<void> {
  const attribution = getStoredAttribution();
  const res = await fetch(`${BASE}/waitlist`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email,
      source,
      utmSource: attribution?.utmSource,
      utmMedium: attribution?.utmMedium,
      utmCampaign: attribution?.utmCampaign,
    }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new ApiError(res.status, body.error ?? res.statusText);
  }
}
